var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 6.99961L13.3996 0.599609M10.8396 6.99961C10.8396 9.12038 9.12038 10.8396 6.99961 10.8396C4.87884 10.8396 3.15961 9.12038 3.15961 6.99961C3.15961 4.87884 4.87884 3.15961 6.99961 3.15961C9.12038 3.15961 10.8396 4.87884 10.8396 6.99961ZM13.3996 6.99961C13.3996 10.5342 10.5342 13.3996 6.99961 13.3996C3.46499 13.3996 0.599609 10.5342 0.599609 6.99961C0.599609 3.46499 3.46499 0.599609 6.99961 0.599609C10.5342 0.599609 13.3996 3.46499 13.3996 6.99961Z",
    stroke: "#A3A3A3",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeVector);
export default __webpack_public_path__ + "static/media/life_vector.51548f565133e55556c168adf0cb86af.svg";
export { ForwardRef as ReactComponent };